exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports
exports.push([module.id, "@import url(https://fonts.googleapis.com/css?family=Nunito:300,400,500,600|Source+Sans+Pro:300,400,500,600,700,800,900);", ""]);
exports.i(require("-!../../../../node_modules/css-loader/index.js!antd/dist/antd.css"), "");

// module
exports.push([module.id, ".confirmation-message .title {\n  display: block;\n  margin-bottom: 1.8rem; }\n\n.confirmation-message .order-id {\n  margin: 1.8rem 0;\n  color: #ef3d42;\n  font-weight: bold; }\n\n.confirmation-message a {\n  color: #8b3187;\n  text-decoration: underline;\n  text-transform: lowercase; }\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./node_modules/sass-loader/lib/loader.js?sourceMap=true!./src/pages/OrderConfirmationPage/ConfirmationMessage/ConfirmationMessage.scss
// module id = 1647
// module chunks = 0